<div class="overlay-loader" *ngIf="isLoading">
  <div class="spinner-box">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</div>
<div class="orders-container" *ngIf="outstandingReport$ | async as outstandingReport">
  <mat-card>
    <mat-card-title>Outstanding Report</mat-card-title>
    <mat-card-content>
      <!-- <table mat-table [dataSource]="outstandingReport" class="mat-elevation-z2 orders-table"> -->
      <table mat-table [dataSource]="outstandingReport | slice:(pageIndex * pageSize):((pageIndex + 1) * pageSize)"
        class="mat-elevation-z2 orders-table">
        <ng-container matColumnDef="slno">
          <th mat-header-cell *matHeaderCellDef> Sl No. </th>
          <td mat-cell *matCellDef="let item; let i = index"> {{ (pageIndex * pageSize) + i + 1 }} </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>  Number. </th>
          <td mat-cell *matCellDef="let item">{{item.name}}</td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let item"> {{ item.date | date:'dd-MM-yyyy' }} </td>
        </ng-container>

        <ng-container matColumnDef="due_date">
          <th mat-header-cell *matHeaderCellDef> Due Date </th>
          <td mat-cell *matCellDef="let item"> {{ item.due_date | date:'dd-MM-yyyy' }} </td>
        </ng-container>

        <ng-container matColumnDef="amount_total">
          <th mat-header-cell *matHeaderCellDef> Total Amount </th>
          <td mat-cell *matCellDef="let item"> {{item.currency}} {{ item.amount_total }} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Bill Status </th>
          <td mat-cell *matCellDef="let item"> {{ item.status }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      <mat-paginator [length]="outstandingReport.length" *ngIf="outstandingReport.length > 5" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons (page)="onPageChange($event)">
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>